import * as React from 'react';
import { IncentiveAttachment } from '../../../typedefs/store';
import styled from 'styled-components';
import * as CashIcon from 'react-icons/lib/io/cash';

interface Props {
    attachment: IncentiveAttachment;
}

const IncentiveAttachment: React.SFC<Props> = ({ attachment }) => {
    return (
        <Wrapper>
            <IconWrapper>
                <CashIcon size={32} />
            </IconWrapper>
            <IncentiveWrapper>
                <Title>{attachment.title}</Title>
                <Text>{attachment.incentive}</Text>
            </IncentiveWrapper>
        </Wrapper>
    );
};

export default IncentiveAttachment;

const Wrapper = styled.div`
    display: flex;
    align-items: center;
`;

const IconWrapper = styled.div`
    flex-grow: 0;
    flex-shrink: 0;
    padding-right: 10px;
`;
const IncentiveWrapper = styled.div`flex-grow: 1;`;

const Title = styled.div`margin-bottom: 5px;`;
const Text = styled.div`
    font-size: 0.8em;
    line-height: 1.3;
`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Shared/Attachments/IncentiveAttachment.tsx